import { cn, Flex } from '@bridebook/aura';
import {
  TDetailsSections,
  TPreviewSections,
  useEditorSyncContext,
} from '@bridebook/web/components/wedding-website/main/desktop/editor-sync-context';
import { PropsWithChildren, useEffect, useRef } from 'react';
import { FloatingEditButton } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/floating-edit-button';

export const SectionContainer = ({
  children,
  className,
  detailsSectionId,
  previewSectionId,
}: PropsWithChildren<{
  className?: string;
  detailsSectionId?: TDetailsSections;
  previewSectionId?: TPreviewSections;
}>) => {
  const { registerPreviewRef } = useEditorSyncContext();
  const tileRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (previewSectionId) registerPreviewRef(previewSectionId, tileRef.current);
  }, [registerPreviewRef, previewSectionId]);

  return (
    <Flex
      ref={tileRef}
      className={cn(
        'group relative w-full max-w-[440px] flex-col items-center gap-[32px] px-[32px] py-[60px] @screen-lg:max-w-none @screen-lg:gap-[40px] @screen-lg:px-[var(--section-padding-lg)] @screen-lg:py-[80px]',
        className,
      )}>
      {children}
      {detailsSectionId && <FloatingEditButton detailsSectionId={detailsSectionId} />}
    </Flex>
  );
};
